import React from "react";

import { Edit } from "icons";

import { Button, Typography } from "clearsense-ui/components";

const VariationAccordion = ({
  variationIndex,
  variation,
  handleUpdateVariation,
}) => (
  <div className="mt-2 w-full">
    <div className="bg-gray-50 flex justify-between items-center border border-solid border-gray-300 w-full p-2 mb-2">
      <Typography type="bold">{variation.name}</Typography>
      <div className="flex items-center gap-10">
        <Button
          data-cy="variation-edit-button"
          style="text"
          icon={() => <Edit size="20" />}
          key={variationIndex}
          onClick={() => handleUpdateVariation(variationIndex)}
        />
      </div>
    </div>
  </div>
);

export default VariationAccordion;
